import axios from 'axios';

axios.defaults.baseURL = '/api';

export async function resetPassword(token: string, password: string) {
    await axios.post('/resetPassword', { token, password });
}
